import * as React from 'react';
import { Box, Flex, Text, Button, List, Alert, AlertIcon, AlertTitle, AlertDescription } from '@chakra-ui/react';

import { Modal } from '../../../atoms/modal';
import { getTrackerStatus, TrackerStep } from '../../../../utilities/casTracker';
import { TimeIndicator } from '../../../atoms/TimeIndicator';

import { CASTrackerItem } from './CASTrackerItem';

import { ISummary } from 'api-paths-cas';

interface IProps {
  onClose: () => void;
  summary: ISummary;
}

const CASTracker: React.FC<IProps> = (props: IProps) => {
  const { step, progress } = getTrackerStatus(props.summary);

  const renderCasInProgress = () => {
    return (
      <List as="ol">
        <CASTrackerItem isComplete>All tasks complete</CASTrackerItem>

        <CASTrackerItem
          isActive={step === TrackerStep.CAS_REQUEST_RECEIVED}
          isComplete={step >= TrackerStep.CAS_REQUEST_RECEIVED}
        >
          We have received your CAS request
        </CASTrackerItem>

        <CASTrackerItem
          isActive={step === TrackerStep.CAS_REQUEST_REVIEWING}
          isComplete={step >= TrackerStep.CAS_REQUEST_REVIEWING}
        >
          We are reviewing your data and documents
        </CASTrackerItem>

        <CASTrackerItem isActive={step === TrackerStep.CAS_PROCESSING} isComplete={step >= TrackerStep.CAS_PROCESSING}>
          Your CAS is being processed
        </CASTrackerItem>

        <CASTrackerItem>CAS issued</CASTrackerItem>
      </List>
    );
  };

  const renderCasIssued = () => {
    return (
      <>
        <Alert status="success">
          <AlertIcon />

          <Box>
            <AlertTitle>CAS Issued</AlertTitle>

            <AlertDescription>
              <Text>Your CAS has been successfully processed by UKVI.</Text>
              <Text mb={0}>Please allow time for delivery of your CAS number.</Text>
            </AlertDescription>
          </Box>
        </Alert>
      </>
    );
  };

  return (
    <Modal
      id={'cas-tracker'}
      show={true}
      title="Track the status of your CAS document"
      onClose={props.onClose}
      footer={
        <Button onClick={props.onClose} variant="solid" size="lg">
          Close Window
        </Button>
      }
    >
      <Flex
        flexDirection={{ base: 'column', sm: 'row' }}
        alignItems={{ base: 'center', sm: 'start' }}
        justifyContent="center"
        rowGap={3}
        columnGap={8}
      >
        <TimeIndicator value={progress} label={`${progress}%`} />

        <Box>{step === TrackerStep.CAS_ISSUED ? renderCasIssued() : renderCasInProgress()}</Box>
      </Flex>
    </Modal>
  );
};

export { CASTracker };
